import { Injectable } from '@angular/core';
import { ModalComponent } from '@coreui/angular';
import { DefaultModalComponent } from './modal-component/modal.component';
import { GetDefaultConfig, IModalConfig, IModalExplorerConfig } from './modal';


export interface iModalEntry {
  level: number;
  modalRef: DefaultModalComponent;
}

@Injectable({
  providedIn: 'root'
})
export class OptimaDefaultModalService {
  constructor() { }
  private _modalRefs: iModalEntry[] = [];

  private currentLevel: number = 0; //when none is showing, this

  register(modalRef: DefaultModalComponent, level: number) {
    this._modalRefs.push({ level, modalRef });
  }

  // getModalRef(level: number): DefaultModalComponent | undefined {
  //   return this._modalRefs.find(ref => ref.level === level)?.modalRef;
  // }

  show(config: IModalConfig | IModalExplorerConfig = GetDefaultConfig()) {
    let newLevel = this.currentLevel + 1;
    let instanceAtLevel = this._modalRefs.find(ref => ref.level === newLevel)?.modalRef;
    if (instanceAtLevel) {
      this.currentLevel = newLevel;
      instanceAtLevel.show(config);
    }
  }

  onDialogClose(level: number) {
    //sanity check
    if (level === this.currentLevel) {
      let instanceAtLevel = this._modalRefs.find(ref => ref.level === level)?.modalRef;
      if (instanceAtLevel) {
        this.currentLevel = level - 1;
      }
    } else {
      throw new Error('Invalid level. LIFO not followed');
    }
  }

}
